import React from "react";
import { useNavigate } from "react-router-dom";
import "./StripeStatus.css";

const SuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="status-container success">
      <div className="status-card">
        <h1>✅ Payment Successful!</h1>
        <p>Your subscription is now active. Thank you for choosing <strong>Full Trucking Service</strong>.</p>
        <button className="status-btn primary" onClick={() => navigate("/login")}>
          Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default SuccessPage;
